var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "summary" }, [
    _vm.loading === false
      ? _c("div", { staticClass: "flex-row" }, [
          _c("div", { staticClass: "summaries__wrapper" }, [
            _c("div", [
              _c("div", { staticClass: "summary__item padless" }, [
                _c("h1", [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.strings["cart_title"]) +
                      "\n                    "
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", [
              _c("div", { staticClass: "summary__item user_check" }, [
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(_vm.strings["are_you_correct_user"])
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", [
              _c("div", { staticClass: "summary__item" }, [
                _c("div", { staticClass: "flex-ns justify-between mb2" }, [
                  _c("h2", [
                    _vm._v(
                      "\n                            1.\n                            " +
                        _vm._s(_vm.strings["summary_addresses_shipping"]) +
                        "\n                        "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "underline",
                      staticStyle: { cursor: "pointer" },
                      on: { click: _vm.activeNote }
                    },
                    [_vm._v(_vm._s(_vm.strings["added_shipping_notes"]))]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "pt2 pb3" }, [
                  _vm.address.list.length > 0
                    ? _c("div", [
                        _c("div", { staticClass: "pl3-ns" }, [
                          _vm.address.same && _vm.address.alternativeChecked
                            ? _c("div", { staticClass: "pb1 ttu" }, [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(
                                      _vm.strings["summary_addresses_invoice"]
                                    ) +
                                    "\n                                "
                                )
                              ])
                            : _c("div", { staticClass: "pb1 ttu" }, [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(
                                      _vm.strings["summary_addresses_shipping"]
                                    ) +
                                    "\n                                "
                                )
                              ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "flex flex-wrap" },
                            _vm._l(_vm.address.list, function(info, key) {
                              return _c("address-item", {
                                key: key,
                                staticClass: "pr4 pb3",
                                attrs: {
                                  address: info,
                                  strings: _vm.strings,
                                  selected: _vm.paymentaddress,
                                  alternative: false
                                },
                                on: { "set-address-on": _vm.chageAddress }
                              })
                            }),
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _vm.noaddress
                          ? _c("div", { staticClass: "pl3" }, [
                              _c(
                                "span",
                                {
                                  staticClass: "underline",
                                  staticStyle: { cursor: "pointer" },
                                  on: {
                                    click: function($event) {
                                      return _vm.$emit("change-new-address")
                                    }
                                  }
                                },
                                [_vm._v("Change")]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.address.same && _vm.address.alternativeChecked
                          ? _c(
                              "div",
                              { staticClass: "pl3-ns pt4" },
                              [
                                _c("div", { staticClass: "pb1 ttu" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        _vm.strings[
                                          "summary_addresses_shipping"
                                        ]
                                      ) +
                                      "\n                                "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("address-item", {
                                  attrs: {
                                    address: _vm.address.alternative,
                                    strings: _vm.strings,
                                    alternative: true
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.address.list.length < 5
                          ? _c("div", {
                              staticClass: "pl3-ns pt4",
                              domProps: {
                                innerHTML: _vm._s(_vm.strings["guest_address"])
                              }
                            })
                          : _vm._e()
                      ])
                    : _c(
                        "div",
                        [
                          _c("address-map", {
                            attrs: {
                              address: _vm.addressempty,
                              strings: _vm.strings,
                              countries: _vm.address.countries,
                              country: _vm.cart.country.iso
                            },
                            on: {
                              check: function($event) {
                                return _vm.$emit("check-new-address")
                              }
                            }
                          })
                        ],
                        1
                      )
                ]),
                _vm._v(" "),
                _vm.notes
                  ? _c("div", { staticClass: "pl3-ns" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c(
                          "label",
                          {
                            staticClass: "control-label ttu",
                            attrs: { for: "notes" }
                          },
                          [_vm._v(_vm._s(_vm.strings["shipping_notes"]))]
                        ),
                        _vm._v(" "),
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.address.note,
                              expression: "address.note"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { id: "notes" },
                          domProps: { value: _vm.address.note },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(_vm.address, "note", $event.target.value)
                            }
                          }
                        })
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                (_vm.cart.country.iso == "IT" ||
                  _vm.cart.country.iso == "SM") &&
                _vm.address.sameInvoice
                  ? _c("div", { staticClass: "row ph2 pv3" }, [
                      _c("div", { staticClass: "form-group col-xs-12" }, [
                        _c(
                          "label",
                          {
                            staticClass: "control-label",
                            attrs: { for: "choice" }
                          },
                          [_vm._v(_vm._s(_vm.strings["bill_to"]))]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.address.choice,
                              expression: "address.choice"
                            }
                          ],
                          attrs: {
                            id: "choice_person",
                            name: "choice",
                            type: "radio",
                            value: "person",
                            disabled: _vm.address.sameInvoice === false
                          },
                          domProps: {
                            checked: _vm._q(_vm.address.choice, "person")
                          },
                          on: {
                            change: function($event) {
                              return _vm.$set(_vm.address, "choice", "person")
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "control-label show-label",
                            attrs: { for: "choice_person" }
                          },
                          [_vm._v(_vm._s(_vm.strings["choices_person"]))]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.address.choice,
                              expression: "address.choice"
                            }
                          ],
                          attrs: {
                            id: "choice_company",
                            name: "choice",
                            type: "radio",
                            value: "company",
                            disabled: _vm.address.sameInvoice === false
                          },
                          domProps: {
                            checked: _vm._q(_vm.address.choice, "company")
                          },
                          on: {
                            change: function($event) {
                              return _vm.$set(_vm.address, "choice", "company")
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "control-label show-label",
                            attrs: { for: "choice_company" }
                          },
                          [_vm._v(_vm._s(_vm.strings["choices_company"]))]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-group col-xs-12 col-md-6" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "control-label",
                              attrs: { for: "company_name" }
                            },
                            [_vm._v(_vm._s(_vm.strings["company_name"]))]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.address.companyName,
                                expression: "address.companyName"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              disabled: _vm.address.sameInvoice === false,
                              name: "company_name",
                              type: "text",
                              id: "company_name",
                              placeholder: _vm.strings["company_name"]
                            },
                            domProps: { value: _vm.address.companyName },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.address,
                                  "companyName",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-group col-xs-12 col-md-6" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "control-label",
                              attrs: { for: "tax_code" }
                            },
                            [_vm._v("Codice fiscale")]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.address.taxCode,
                                expression: "address.taxCode"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              disabled: _vm.address.sameInvoice === false,
                              name: "tax_code",
                              type: "text",
                              id: "tax_code",
                              placeholder: "Codice fiscale"
                            },
                            domProps: { value: _vm.address.taxCode },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.address,
                                  "taxCode",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "form-group col-xs-12 col-md-6",
                          class: {
                            disabled:
                              _vm.address.sameInvoice === false ||
                              _vm.address.choice == "person"
                          }
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "control-label",
                              attrs: { for: "vat_number" }
                            },
                            [_vm._v(_vm._s(_vm.strings["vat_number"]))]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.address.vatNumber,
                                expression: "address.vatNumber"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              disabled:
                                _vm.address.sameInvoice === false ||
                                _vm.address.choice == "person",
                              name: "vat_number",
                              type: "text",
                              id: "vat_number",
                              placeholder: _vm.strings["vat_number"]
                            },
                            domProps: { value: _vm.address.vatNumber },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.address,
                                  "vatNumber",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "form-group col-xs-12 col-md-6",
                          class: {
                            disabled:
                              _vm.address.sameInvoice === false ||
                              _vm.address.choice == "person"
                          }
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "control-label",
                              attrs: { for: "pec_email" }
                            },
                            [_vm._v("Email PEC")]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.address.pecEmail,
                                expression: "address.pecEmail"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              disabled:
                                _vm.address.sameInvoice === false ||
                                _vm.address.choice == "person",
                              name: "pec_email",
                              type: "email",
                              id: "pec_email",
                              placeholder: _vm.strings["pec_email"]
                            },
                            domProps: { value: _vm.address.pecEmail },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.address,
                                  "pecEmail",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "form-group col-xs-12 col-md-6",
                          class: {
                            disabled:
                              _vm.address.sameInvoice === false ||
                              _vm.address.choice == "person"
                          }
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "control-label",
                              attrs: { for: "codice_univoco_fatturazione" }
                            },
                            [_vm._v("Codice Univoco Fatturazione")]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.address.sdi,
                                expression: "address.sdi"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              disabled:
                                _vm.address.sameInvoice === false ||
                                _vm.address.choice == "person",
                              name: "codice_univoco_fatturazione",
                              type: "text",
                              id: "codice_univoco_fatturazione",
                              placeholder:
                                _vm.strings["codice_univoco_fatturazione"]
                            },
                            domProps: { value: _vm.address.sdi },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.address,
                                  "sdi",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "checkboxes-wrapper" }, [
                  _c(
                    "div",
                    { staticClass: "form-group form-group--mb0 mr5-ns mr3" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.address.same,
                            expression: "address.same"
                          }
                        ],
                        attrs: { id: "same", name: "same", type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(_vm.address.same)
                            ? _vm._i(_vm.address.same, null) > -1
                            : _vm.address.same
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.address.same,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.address,
                                    "same",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.address,
                                    "same",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.address, "same", $$c)
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "control-label show-label",
                          attrs: { for: "same" }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.strings["invoice_same_as_shipping"])
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.cart.country.iso == "IT" || _vm.cart.country.iso == "SM"
                    ? _c("div", { staticClass: "form-group form-group--mb0" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.address.sameInvoice,
                              expression: "address.sameInvoice"
                            }
                          ],
                          attrs: {
                            id: "same_invoice",
                            name: "same_invoice",
                            type: "checkbox"
                          },
                          domProps: {
                            checked: Array.isArray(_vm.address.sameInvoice)
                              ? _vm._i(_vm.address.sameInvoice, null) > -1
                              : _vm.address.sameInvoice
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.address.sameInvoice,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.address,
                                      "sameInvoice",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.address,
                                      "sameInvoice",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(_vm.address, "sameInvoice", $$c)
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "control-label show-label",
                            attrs: { for: "same_invoice" }
                          },
                          [_vm._v(_vm._s(_vm.strings["invoice_same"]))]
                        )
                      ])
                    : _vm._e()
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", [
              _vm.address.same && _vm.address.alternativeChecked === false
                ? _c("div", { staticClass: "summary__item" }, [
                    _c(
                      "div",
                      { staticClass: "pl3-ns pt3" },
                      [
                        _c("div", { staticClass: "pb1 ttu" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.strings["insert"]) +
                              "\n                            " +
                              _vm._s(
                                _vm.strings["summary_addresses_shipping"]
                              ) +
                              "\n                        "
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "pb1 i pb3" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.strings["shipping_remaind"]) +
                              "\n                        "
                          )
                        ]),
                        _vm._v(" "),
                        _c("address-map", {
                          attrs: {
                            address: _vm.address.alternative,
                            strings: _vm.strings,
                            countries: _vm.address.countries,
                            country: _vm.cart.country.iso
                          },
                          on: {
                            check: function($event) {
                              return _vm.$emit("check-address")
                            }
                          }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticStyle: { width: "100%" } }, [
              _c("div", { staticClass: "summary__item" }, [
                _c("h2", { staticClass: "mb2" }, [
                  _vm._v("2. " + _vm._s(_vm.strings["payment_methods"]))
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "payments-grid" },
                  [
                    _vm._l(_vm.payments, function(method, key) {
                      return _c("payment-method", {
                        key: key,
                        attrs: {
                          idlist: key,
                          payment: method,
                          strings: _vm.strings,
                          checkout: _vm.checkout
                        },
                        on: { change: _vm.changePayment }
                      })
                    }),
                    _vm._v(" "),
                    _c("div", { attrs: { id: "AmazonPayButton" } })
                  ],
                  2
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticStyle: { width: "100%" } }, [
              _c("div", { staticClass: "summary__item" }, [
                _c("h2", { staticClass: "mb2" }, [
                  _vm._v("3. " + _vm._s(_vm.strings["review_the_articles"]))
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "cart-items-list" },
                  _vm._l(_vm.cart.items, function(product, key) {
                    return _c("cart-item", {
                      key: key,
                      attrs: {
                        product: product,
                        currency: _vm.cart.currency,
                        strings: _vm.strings,
                        recap: true
                      },
                      on: {
                        add: function($event) {
                          return _vm.$emit("update-item", key, "add")
                        },
                        remove: function($event) {
                          return _vm.$emit("update-item", key, "remove")
                        }
                      }
                    })
                  }),
                  1
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", [
            _c("div", { staticClass: "summaries__wrapper bordered" }, [
              _c("div", { staticClass: "summary__item" }, [
                _c("p", { staticClass: "pb1 regular-font" }, [
                  _vm._v(_vm._s(_vm.strings["order_summary"]))
                ]),
                _vm._v(" "),
                _vm.cart.promoCheck
                  ? _c("div", { staticClass: "flex-row regular-font" }, [
                      _c("span", [_vm._v(_vm._s(_vm.strings["coupon"]))]),
                      _vm._v(" "),
                      _c("span", { staticClass: "fw4" }, [
                        _vm._v(_vm._s(_vm.cart.promoCode))
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "flex-row regular-font" }, [
                  _c("span", [_vm._v(_vm._s(_vm.strings["articles"]) + ":")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.cart.totalItems))])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flex-row regular-font" }, [
                  _c("span", [_vm._v(_vm._s(_vm.strings["subtotal"]) + ":")]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.cart.currency) +
                        "\n                            " +
                        _vm._s(_vm.cart.subtotal.toFixed(2))
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm.cart.subtotalPromo > 0
                  ? _c("div", { staticClass: "flex-row regular-font" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.strings["promo_discount_label"]) + ":"
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.cart.currency) +
                            " -\n                            " +
                            _vm._s(_vm.cart.subtotalPromo.toFixed(2))
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.cart.giftDiscount > 0
                  ? _c("div", { staticClass: "flex-row regular-font" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.strings["giftcard_discount_label"]) + ":"
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.cart.currency) +
                            " - " +
                            _vm._s(_vm.cart.giftDiscount.toFixed(2))
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "flex-row regular-font" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.strings["shipping_cost"]) + ":"),
                    _c("br"),
                    _vm._v("(" + _vm._s(_vm.cart.country.name) + ")")
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.cart.currency) +
                        "\n                            " +
                        _vm._s(_vm.cart.shippingCost.toFixed(2))
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "flex-row regular-font",
                    staticStyle: { "flex-wrap": "wrap" }
                  },
                  [
                    _c("div", { staticClass: "summary__total" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.strings["total"]) +
                          ":\n                        "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "summary__total" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.cart.currency) +
                          " " +
                          _vm._s(_vm.cart.total.toFixed(2)) +
                          "\n                        "
                      )
                    ]),
                    _vm._v(" "),
                    _vm.cart.country.iso == "US"
                      ? _c(
                          "div",
                          {
                            staticClass: "form-group form-group--mb0",
                            staticStyle: { width: "100%" }
                          },
                          [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-size": "12px",
                                  "margin-top": "-10px",
                                  color: "red",
                                  width: "100%"
                                }
                              },
                              [_vm._v("Duties and shipping cost excluded")]
                            )
                          ]
                        )
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "summary__button",
                    class: { show: _vm.checkout.showPaymantButton }
                  },
                  [
                    _c("div", { ref: "paypalButton" }),
                    _vm._v(" "),
                    _c("div", {
                      ref: "payButton",
                      domProps: { innerHTML: _vm._s(_vm.paymentbutton) }
                    })
                  ]
                ),
                _vm._v(" "),
                _vm.checkout.showPaymantButton == false
                  ? _c("div", [
                      _vm.giftcardblocked
                        ? _c("div", { staticClass: "giftcard-block-alert" }, [
                            _c("b", [_vm._v("Attenzione")]),
                            _c("br"),
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.giftcardmessage) +
                                "\n                        "
                            )
                          ])
                        : _c(
                            "button",
                            {
                              staticClass: "btn btn-primary w-100",
                              staticStyle: { padding: "10px" },
                              on: { click: _vm.checkButton }
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.strings["pay"]) +
                                  "\n                        "
                              )
                            ]
                          ),
                      _vm._v(" "),
                      _c("div", { staticClass: "pt3 checkbox__wrapper" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.checkout.readAgree,
                                expression: "checkout.readAgree"
                              }
                            ],
                            attrs: {
                              id: "read_agree",
                              name: "read_agree",
                              type: "checkbox"
                            },
                            domProps: {
                              checked: Array.isArray(_vm.checkout.readAgree)
                                ? _vm._i(_vm.checkout.readAgree, null) > -1
                                : _vm.checkout.readAgree
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.checkout.readAgree,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.checkout,
                                        "readAgree",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.checkout,
                                        "readAgree",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.checkout, "readAgree", $$c)
                                }
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("label", {
                            staticClass: "control-label read_agree",
                            attrs: { for: "read_agree" },
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.strings["selling_conditions"]
                              )
                            }
                          }),
                          _vm._v(" "),
                          _vm.checkAgree
                            ? _c(
                                "span",
                                { staticClass: "help-block error-help-block" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.strings["selling_conditions_error"]
                                    )
                                  )
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "tr" }, [
                          _c("small", [_vm._v(_vm._s(_vm.strings["required"]))])
                        ]),
                        _vm._v(" "),
                        _vm.shippingrussian === true
                          ? _c("div", { staticClass: "tr" }, [
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.strings["shipping_russian"]
                                  )
                                }
                              })
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.activebuy == false
                          ? _c("div", { staticClass: "row" }, [
                              _c(
                                "div",
                                { staticClass: "col-xs-12 tc mb5 mt3" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "pa3",
                                      staticStyle: {
                                        "background-color": "white"
                                      }
                                    },
                                    [
                                      _c("h3", [
                                        _c("b", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.strings["minimum_order_gb"]
                                            )
                                          )
                                        ])
                                      ])
                                    ]
                                  )
                                ]
                              )
                            ])
                          : _vm._e()
                      ])
                    ])
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _vm.cart.promoCheck
              ? _c("div", { staticClass: "pt4 pl3-ns" }, [
                  _c("span", { staticClass: "mb2 mb0-ns ttu" }, [
                    _vm._v(_vm._s(_vm.strings["coupon"]))
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "fw4" }, [
                    _vm._v(_vm._s(_vm.cart.promoCode))
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass:
                        "cart-totals-promo-remove bttn ttu ml4-ns ml0 mt2 mt0-ns",
                      on: {
                        click: function($event) {
                          return _vm.$emit("delete-promo")
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "far fa-times" }),
                      _vm._v(
                        "  " +
                          _vm._s(_vm.strings["remove_coupon"]) +
                          "\n                "
                      )
                    ]
                  )
                ])
              : _c("div", { staticClass: "pt4" }, [
                  _c("span", [_vm._v(_vm._s(_vm.strings["promo_label"]))]),
                  _vm._v(" "),
                  _c("div", { staticClass: "promo__form" }, [
                    _c("input", {
                      staticClass: "mh2-ns mt3 mt0-ns",
                      staticStyle: { "padding-left": "12px!important" },
                      attrs: {
                        type: "text",
                        id: "promoCode",
                        placeholder: "Coupon"
                      },
                      domProps: { value: _vm.cart.promoCode },
                      on: {
                        input: function($event) {
                          _vm.cart.promoCode = $event.target.value.toUpperCase()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass:
                          "cart-totals-promo-submit bttn ttu mb3 mb0-ns",
                        on: {
                          click: function($event) {
                            return _vm.$emit("add-promo", _vm.cart.promoCode)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.strings["update"]) +
                            "\n                        "
                        ),
                        _c("i", { staticClass: "far fa-spinner-third fa-spin" })
                      ]
                    )
                  ])
                ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "summary__loading",
              class: { opened: _vm.loadingpage === true }
            },
            [_vm._m(0)]
          )
        ])
      : _c("div", { staticClass: "text-center" }, [
          _c("div", { staticClass: "loader" }, [_vm._v("Loading...")])
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "flex justify-center content-center items-center" },
      [_c("div", { staticClass: "loader" }, [_c("b", [_vm._v("Updating...")])])]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }